module.exports = __webpack_public_path__ + "img/tramites_procesados.a3db6423.png";